import{A as r,w as e,x as o}from"../chunk-MG7VRERG.js";import"../chunk-JORWOKR3.js";e.isCreated()||e.createContext();export{o as mudCoreConfig,r as resolveTableId};
//# sourceMappingURL=register.js.map